import React, { useEffect, useState } from "react";
import { ShieldCheck, RotateCcw, XCircle, CheckCircle2 } from "lucide-react";
import { HoloCard } from "@/components/Holo";
import api from "@/lib/api";

const Stat = ({ icon: Icon, label, value, accent }) => (
  <HoloCard accent={accent} className="p-5" testid={`shield-stat-${label}`}>
    <Icon size={18} className="mb-3" style={{ color: `var(--${accent})` }} />
    <div className="font-display font-black text-2xl">{value}</div>
    <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white/40 mt-1">{label}</div>
  </HoloCard>
);

export default function CreditShield() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/credit-shield").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <div className="font-mono-tech text-white/40 text-sm">Loading Credit Shield...</div>;

  return (
    <div data-testid="module-credit_shield">
      <div className="mb-8">
        <h1 className="font-display font-bold text-2xl sm:text-3xl flex items-center gap-3"><ShieldCheck className="text-neon-turquoise" /> Credit Shield</h1>
        <p className="font-mono-tech text-white/40 text-sm mt-1">Failed generations automatically return your credits</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        <Stat icon={ShieldCheck} label="Credits Available" value={data.credits.toLocaleString()} accent="turquoise" />
        <Stat icon={RotateCcw} label="Credits Refunded" value={data.total_refunded} accent="green" />
        <Stat icon={CheckCircle2} label="Successful" value={data.completed_generations} accent="purple" />
        <Stat icon={XCircle} label="Failed (Shielded)" value={data.failed_generations} accent="pink" />
      </div>

      <h2 className="font-mono-tech text-white/50 text-xs uppercase tracking-widest mb-4">// Refund Ledger</h2>
      {data.refunds.length === 0 ? (
        <div className="font-mono-tech text-white/30 text-sm border border-white/10 border-dashed p-10 text-center">No refunds issued. Every render succeeded.</div>
      ) : (
        <HoloCard accent="green" className="overflow-hidden" hover={false}>
          <table className="w-full font-mono-tech text-sm">
            <thead>
              <tr className="text-left text-white/40 text-[10px] uppercase tracking-widest border-b border-white/10">
                <th className="p-4">Timestamp</th><th className="p-4">Amount</th><th className="p-4">Reason</th>
              </tr>
            </thead>
            <tbody>
              {data.refunds.map((r) => (
                <tr key={r.id} className="border-b border-white/5" data-testid={`refund-${r.id}`}>
                  <td className="p-4 text-white/60">{new Date(r.created_at).toLocaleString()}</td>
                  <td className="p-4 text-neon-green">+{r.amount}</td>
                  <td className="p-4 text-white/50">{r.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </HoloCard>
      )}
    </div>
  );
}
